import {isEqual, cloneDeep, forEach} from "lodash";

import {FILE_SIZES} from "../../../../constants/file-sizes.constant";

const PROMPTING_SERVICE_OPTIONS = [
    {value: "replicate_nano_banana_pro", label: "Nano Banana Pro"},
    {value: "replicate_nano_banana_2", label: "Nano Banana 2"},
    {value: "replicate_flux_kontext_pro", label: "Flux Kontext Pro"},
    // ur-119 models are not offered yet: remove "hidden" to show a model in the list
    {value: "replicate_flux_2_pro", label: "Flux 2 Pro", hidden: true},
    {value: "replicate_seedream_5_lite", label: "Seedream 5 Lite", hidden: true},
    {value: "replicate_grok_imagine_image_quality", label: "Grok Imagine Image Quality", hidden: true}
];

const PROMPTING_DEFAULTS = {
    replicate_nano_banana_pro: {
        service: "replicate_nano_banana_pro",
        prompt: "",
        image_input: [],
        aspect_ratio: "4:3",
        resolution: "2K",
        output_format: "jpg",
        safety_filter_level: "block_only_high",
        allow_fallback_model: false
    },
    replicate_nano_banana_2: {
        service: "replicate_nano_banana_2",
        prompt: "",
        image_input: [],
        aspect_ratio: "4:3",
        resolution: "1K",
        google_search: false,
        image_search: false,
        output_format: "jpg"
    },
    replicate_flux_kontext_pro: {
        service: "replicate_flux_kontext_pro",
        prompt: "",
        input_image: "",
        aspect_ratio: "4:3",
        prompt_upsampling: false,
        seed: null,
        output_format: "png",
        safety_tolerance: 2
    },
    replicate_flux_2_pro: {
        service: "replicate_flux_2_pro",
        prompt: "",
        input_images: [],
        aspect_ratio: "1:1",
        resolution: "1 MP",
        output_format: "jpg",
        output_quality: 80,
        safety_tolerance: 2,
        prompt_upsampling: false
    },
    replicate_seedream_5_lite: {
        service: "replicate_seedream_5_lite",
        prompt: "",
        image: [],
        aspect_ratio: "match_input_image",
        size: "2K",
        sequential_image_generation: "disabled",
        max_images: null,
        output_format: "png"
    },
    replicate_grok_imagine_image_quality: {
        service: "replicate_grok_imagine_image_quality",
        prompt: "",
        image: "",
        aspect_ratio: "auto",
        resolution: "2k"
    }
};

const PROMPTING_OPTIONS = {
    aspect_ratio: [
        "match_input_image", "1:1", "2:3", "3:2", "3:4", "4:3", "4:5", "5:4", "9:16", "16:9", "21:9",
        "1:4", "4:1", "1:8", "8:1"
    ],
    resolution: ["512px", "1K", "2K", "4K"],
    output_format: ["jpg", "png"],
    safety_filter_level: ["block_low_and_above", "block_medium_and_above", "block_only_high"],
    replicate_flux_2_pro: {
        aspect_ratio: [
            "match_input_image", "1:1", "2:3", "3:2", "3:4", "4:3", "4:5", "5:4", "9:16", "16:9", "21:9"
        ],
        resolution: ["1 MP", "2 MP", "4 MP"],
        output_format: ["jpg", "png", "webp"]
    },
    replicate_seedream_5_lite: {
        aspect_ratio: ["match_input_image", "1:1", "2:3", "3:2", "3:4", "4:3", "9:16", "16:9", "21:9"],
        size: ["2K", "3K"],
        sequential_image_generation: ["disabled", "auto"],
        output_format: ["png", "jpeg"]
    },
    replicate_grok_imagine_image_quality: {
        aspect_ratio: ["auto", "1:1", "2:3", "3:2", "3:4", "4:3", "9:16", "16:9"],
        resolution: ["1k", "2k"]
    }
};

function buildPromptingSettings(service, settings) {
    const selectedService = service || "replicate_nano_banana_pro";
    const existingSettings = cloneDeep(settings || {});

    if (!PROMPTING_DEFAULTS[selectedService]) {
        return Object.assign({}, existingSettings, {service: selectedService});
    }

    return Object.assign({}, cloneDeep(PROMPTING_DEFAULTS[selectedService]), existingSettings, {service: selectedService});
}

export const AddSceneController = ($scope, $mdDialog, sceneNumber, callback, company, scene, isEdit, globalData, modes, hideBg, $filter, unscreenIsActive, aiFeature, aiBackground, aiOverlay, isPromptingMode, promptingQuality) => {
    "ngInject";

    $scope.closeDialog = () => {
        $mdDialog.hide();
    };
    $scope.callback = callback;
    $scope.company = company;
    $scope.isEdit = isEdit;
    $scope.aiFeature = aiFeature;
    $scope.aiOverlay = aiOverlay;
    $scope.aiBackground = aiBackground;
    $scope.isPromptingMode = !!isPromptingMode;
    $scope.promptingQuality = promptingQuality || "normal";
    $scope.promptingQualityLabel = {
        pro: "Pro",
        normal: "Normal",
        faster: "Faster"
    }[$scope.promptingQuality] || "Normal";
    $scope.showEdit = false;
    $scope.globalData = globalData;
    $scope.modes = modes;
    $scope.unscreenIsActive = unscreenIsActive;
    $scope.allFiles = [];
    $scope.defaultTypes = ".jpg,.jpeg,.png";
    $scope.animatedBgFiles = ".gif,.mp4";
    $scope.animatedOverlayFiles = ".mp4";
    $scope.sorting = {
        backgrounds: null,
        overlays: null
    };
    $scope.fileSizes = FILE_SIZES;
    $scope.hideBg = hideBg;
    $scope.promptingServiceOptions = PROMPTING_SERVICE_OPTIONS.filter((option) => !option.hidden);
    $scope.promptingOptions = PROMPTING_OPTIONS;
    $scope.promptingFormError = "";
    let oldSceneName = "";

    $scope.ensurePromptingSettings = (selectedService) => {
        if (!$scope.scene.selectedFeature) {
            $scope.scene.selectedFeature = {
                name: "Remove Background (promting)",
                value: "replicate_prompting"
            };
        }

        $scope.scene.selectedFeature.promting_settings = buildPromptingSettings(
            selectedService || ($scope.scene.selectedFeature.promting_settings && $scope.scene.selectedFeature.promting_settings.service),
            $scope.scene.selectedFeature.promting_settings
        );
    };

    $scope.onPromptingServiceChange = () => {
        const currentService = $scope.scene.selectedFeature.promting_settings.service;
        $scope.scene.selectedFeature.promting_settings = buildPromptingSettings(currentService);
        $scope.promptingImageInputText = $scope.getPromptingArrayValue("image_input");
    };

    $scope.getPromptingArrayValue = (fieldName) => {
        const values = $scope.scene.selectedFeature.promting_settings[fieldName];
        return Array.isArray(values) ? values.join("\n") : "";
    };

    $scope.setPromptingArrayValue = (fieldName, rawValue) => {
        $scope.scene.selectedFeature.promting_settings[fieldName] = (rawValue || "")
            .split(/\r?\n|,/)
            .map((item) => item.trim())
            .filter(Boolean);
    };

    $scope.onPromptingSingleImageUpload = (file, fieldName) => {
        const settings = $scope.scene.selectedFeature && $scope.scene.selectedFeature.promting_settings;
        if (!settings) {
            return;
        }

        const batch = Array.isArray(file) ? file : [file];
        const firstValidFile = batch.find((item) => item && item.attachment_file);
        if (firstValidFile) {
            settings[fieldName] = firstValidFile.attachment_file;
        }
    };

    $scope.clearPromptingSingleImage = (fieldName) => {
        if ($scope.scene.selectedFeature && $scope.scene.selectedFeature.promting_settings) {
            $scope.scene.selectedFeature.promting_settings[fieldName] = "";
        }
    };

    $scope.onPromptingInputImageUpload = (file) => {
        $scope.onPromptingSingleImageUpload(file, "input_image");
    };

    $scope.clearPromptingInputImage = () => {
        $scope.clearPromptingSingleImage("input_image");
    };

    $scope.onPromptingArrayImageUpload = (file, fieldName) => {
        const settings = $scope.scene.selectedFeature && $scope.scene.selectedFeature.promting_settings;
        if (!settings) {
            return;
        }
        if (!Array.isArray(settings[fieldName])) {
            settings[fieldName] = [];
        }
        const batch = Array.isArray(file) ? file : [file];
        forEach(batch, (f) => {
            if (f && f.attachment_file && settings[fieldName].indexOf(f.attachment_file) === -1) {
                settings[fieldName].push(f.attachment_file);
            }
        });
        $scope.promptingImageInputText = $scope.getPromptingArrayValue(fieldName);
    };

    $scope.removePromptingArrayImageAt = (fieldName, index) => {
        const settings = $scope.scene.selectedFeature && $scope.scene.selectedFeature.promting_settings;
        if (!settings || !Array.isArray(settings[fieldName])) {
            return;
        }
        settings[fieldName].splice(index, 1);
        $scope.promptingImageInputText = $scope.getPromptingArrayValue(fieldName);
    };

    $scope.clearPromptingArrayImages = (fieldName) => {
        const settings = $scope.scene.selectedFeature && $scope.scene.selectedFeature.promting_settings;
        if (!settings) {
            return;
        }
        settings[fieldName] = [];
        $scope.promptingImageInputText = "";
    };

    $scope.onPromptingImageInputUpload = (file) => {
        $scope.onPromptingArrayImageUpload(file, "image_input");
    };

    $scope.removePromptingImageInputAt = (index) => {
        $scope.removePromptingArrayImageAt("image_input", index);
    };

    $scope.clearPromptingImageInputAll = () => {
        $scope.clearPromptingArrayImages("image_input");
    };

    $scope.isPromptingSettingsValid = () => {
        if (!$scope.isPromptingMode) {
            return true;
        }

        $scope.promptingFormError = "";
        const settings = $scope.scene.selectedFeature && $scope.scene.selectedFeature.promting_settings;
        if (!settings || !settings.service) {
            $scope.promptingFormError = "Select a Replicate service.";
            return false;
        }

        if (!settings.prompt || !settings.prompt.trim()) {
            $scope.promptingFormError = "Prompt is required.";
            return false;
        }

        if (settings.service === "replicate_flux_kontext_pro"
            && settings.safety_tolerance !== null
            && settings.safety_tolerance !== undefined
            && (settings.safety_tolerance < 0 || settings.safety_tolerance > 6)) {
            $scope.promptingFormError = "Safety tolerance must be between 0 and 6.";
            return false;
        }

        return true;
    };

    $scope.create = () => {
        if (!$scope.isPromptingSettingsValid()) {
            return;
        }
        $scope.callback($scope.scene);
        $mdDialog.hide();
    };
    $scope.changeNameOpen = () => {
        $scope.showEdit = true;
        oldSceneName = $scope.scene.title;
        setTimeout(() => {
            document.getElementById("scene-name-change").focus();
            document.addEventListener("keyup", $scope.changeNameUndo);
            document.addEventListener("keyup", $scope.changeNameConfirm);
            document.addEventListener("click", $scope.changeNameConfirm);
        });
    };

    $scope.changeNameConfirm = (e) => {
        if (!e) {
            return;
        }
        const el = document.getElementById("scene-name-change");
        if ((e.key === "Enter" || (e.target && e.target.id !== el.id)) && el && el.checkValidity()) {
            $scope.showEdit = false;
            document.removeEventListener("keyup", $scope.changeNameUndo);
            document.removeEventListener("keyup", $scope.changeNameConfirm);
            document.removeEventListener("click", $scope.changeNameConfirm);
        }
    };

    $scope.changeNameUndo = (e) => {
        if (e.key === "Escape") {
            $scope.scene.title = oldSceneName;
            $scope.showEdit = false;
            document.removeEventListener("keyup", $scope.changeNameUndo);
            document.removeEventListener("keyup", $scope.changeNameConfirm);
            document.removeEventListener("click", $scope.changeNameConfirm);
        }
    };

    $scope.onFilesUpload = (files, type) => {
        if (type === "overlay") {
            if ($scope.scene.enable_animated_overlay_files) {
                $scope.scene.overlayFiles = files;
            } else {
                $scope.scene.overlayFiles.push(...files);
            }
        } else {
            if ($scope.scene.enable_animated_bg_files){
                $scope.scene.backgroundFiles = files;
            } else {
                $scope.scene.backgroundFiles.push(...files);
            }
        }
        $scope.checkAllFiles();
        $scope.getAllFiles();
    };
    $scope.refreshStateOfSceneArray = (value, type) => {
        if (type === "overlay") {
            $scope.scene.overlayFiles = [];
        } else {
            $scope.scene.backgroundFiles = [];
        }
    };

    $scope.checkIfSorted = (arr) => {
        if (!arr || arr.length <= 1) return;
        const originArr = cloneDeep(arr);
        let collator = new Intl.Collator(undefined, {numeric: true, sensitivity: "base"});
        const sortedAsc = cloneDeep(arr).sort((a, b) => collator.compare($filter("getFileName")(a.attachment_file), $filter("getFileName")(b.attachment_file)));
        const sortedDesc = cloneDeep(arr).sort((a, b) => collator.compare($filter("getFileName")(b.attachment_file), $filter("getFileName")(a.attachment_file)));
        if (isEqual(originArr, sortedAsc)) {
            return "asc";
        } else if (isEqual(originArr, sortedDesc)) {
            return "desc";
        } else {
            return "unsorted";
        }
    };

    $scope.checkAllFiles = () => {
        $scope.sorting.backgrounds = $scope.checkIfSorted($scope.scene.backgroundFiles);
        $scope.sorting.overlays = $scope.checkIfSorted($scope.scene.overlayFiles);
    };
    $scope.onDragStart = () => {
        $scope.checkAllFiles();
    };

    $scope.sortFiles = (type) => {
        let collator = new Intl.Collator(undefined, {numeric: true, sensitivity: "base"});
        if (type === "backgrounds") {
            if ($scope.sorting.backgrounds === "asc") {
                $scope.scene.backgroundFiles.sort((a, b) => collator.compare($filter("getFileName")(b.attachment_file), $filter("getFileName")(a.attachment_file)));
            } else {
                $scope.scene.backgroundFiles.sort((a, b) => collator.compare($filter("getFileName")(a.attachment_file), $filter("getFileName")(b.attachment_file)));
            }
        } else {
            if ($scope.sorting.overlays === "asc") {
                $scope.scene.overlayFiles.sort((a, b) => collator.compare($filter("getFileName")(b.attachment_file), $filter("getFileName")(a.attachment_file)));
            } else {
                $scope.scene.overlayFiles.sort((a, b) => collator.compare($filter("getFileName")(a.attachment_file), $filter("getFileName")(b.attachment_file)));
            }
        }
        $scope.checkAllFiles();
    };

    $scope.getFiles = (arr) => {
        if (!arr || !arr.length) return [];
        let newArr = [];
          forEach(arr, (file) => {
              if(file.attachment_file_alpha){
                  newArr.push(file.attachment_file_alpha);
              }else{
                  newArr.push(file.attachment_file);
              }
          });
          return newArr;
    };
    /** Same as scenes-list: single URL for html-preview — avoids JSON url() + missing bgId before second dialog mounts */
    $scope.getFile = (arr) => {
        if (!arr || !arr.length) {
            return [];
        }
        const file = arr[0];
        return file.attachment_file_alpha ? file.attachment_file_alpha : file.attachment_file;
    };
    $scope.getAllFiles = () => {
        $scope.allFiles = [...$scope.getFiles($scope.scene.overlayFiles), ...$scope.getFiles($scope.scene.backgroundFiles)];
    };
    $scope.onLayoutChange = () => {
        if($scope.aiFeature){
            $scope.scene.photos[0].image = true;
            $scope.scene.photos[0].gif = false;
            $scope.scene.photos[0].video = false;
        }else{
            $scope.scene.photos[0].image = $scope.scene.previewStyle === "photo";
            $scope.scene.photos[0].gif = $scope.scene.previewStyle === "gif";
            $scope.scene.photos[0].video = $scope.scene.previewStyle === "boomerang";
        }
    };
    $scope.selectModes = () => {
        if($scope.aiFeature){
            if ($scope.scene.layoutHeight > $scope.scene.layoutWidth){
                $scope.scene.layoutAspectRatio = "portrait";
                $scope.scene.photoAspectRatio = "portrait";
            }else{
                $scope.scene.layoutAspectRatio = "landscape";
                $scope.scene.photoAspectRatio = "landscape";
            }
        }
        switch ($scope.scene.previewStyle) {
            case "photo":
                if ($scope.modes.single) {
                    $scope.scene.previewStyle = "photo";
                }else if (!$scope.modes.single) {
                    $scope.scene.previewStyle = "gif";
                } else if (!$scope.modes.gif) {
                    $scope.scene.previewStyle = "boomerang";
                }
                break;
            case "gif":
                if (!$scope.modes.gif) {
                    $scope.scene.previewStyle = "photo";
                } else if (!$scope.modes.single) {
                    $scope.scene.previewStyle = "boomerang";
                }
                break;
            case "boomerang":
                if (!$scope.modes.boomerang) {
                    $scope.scene.previewStyle = "gif";
                } else if (!$scope.modes.gif) {
                    $scope.scene.previewStyle = "photo";
                }
                break;

        }
        $scope.onLayoutChange();
    };
    $scope.topScroll = (id) => {
        let el = document.getElementById(id);
        if (!el) return;

        return el.scrollTop !== 0;
    };
    $scope.bottomScroll = (id) => {
        let el = document.getElementById(id);
        if (!el) return;

        return el.scrollHeight !== el.clientHeight + el.scrollTop;
    };
    setTimeout(() => {
        $scope.scene = $scope.isEdit ? scene : {
            updateScene: true,
            finalBackground: null,
            finalOverlay: null,
            backgroundFiles: [],
            overlayFiles: [],
            animationTime: 1.5,
            shouldOutputPhotoMirrored: true,
            enabled: true,
            title: "",
            customLayoutHeight: null,
            customLayoutWidth: null,
            layoutAspectRatio: "square",
            layoutHeight: $scope.globalData.layoutHeight,
            layoutWidth: $scope.globalData.layoutWidth,
            customPhotoHeight: null,
            customPhotoWidth: null,
            photoAspectRatio: "square",
            photos: $scope.globalData.photos,
            timestamp: new Date().getTime(),
            previewStyle: "photo"
    };
        if (!Array.isArray($scope.scene.overlayFiles)) {
            $scope.scene.overlayFiles = [];
        }
        if (!Array.isArray($scope.scene.backgroundFiles)) {
            $scope.scene.backgroundFiles = [];
        }
        if ($scope.isPromptingMode) {
            $scope.ensurePromptingSettings();
            $scope.promptingImageInputText = $scope.getPromptingArrayValue("image_input");
        }
        $scope.checkAllFiles();
        $scope.selectModes();
        $scope.getAllFiles();
        if (!$scope.isEdit) {
            $scope.scene.title = `New scene ${sceneNumber}`;
            if ($scope.aiOverlay) {
                $scope.scene.title = `New overlay ${sceneNumber}`;
            }
            if ($scope.aiBackground) {
                $scope.scene.title = `NEW TARGET IMAGE ${sceneNumber}`;
            }
        }
    });
};



// WEBPACK FOOTER //
// ./sources/components/configurations/scenes-list/add-scene/add-scene.js